<ng-container *ngIf="board.columns?.length">

  <div class="row">
    <div class="col-2">
      <tui-input
        tuiTextfieldSize="s"
        [formControl]="inputFormControl"
        [tuiTextfieldCleaner]="true"
      >
        Поиск
        <input tuiTextfieldLegacy/>
      </tui-input>
    </div>

    <div class="col-2  group select-assignee"
         tuiGroup
         *ngIf="assigneeList?.length"
         [collapsed]="true">
      <tui-avatar
        *ngIf="!!currentAssignee"
        class="myAssignee"
        [style.flex]="'0 0 auto'"
        size="s"
        (click)="toggleMyAssignee()"
        nbTooltipPlacement="bottom"
        nbTooltip="Мои задачи"
        [src]="currentAssignee.avatar ? getImageUri(currentAssignee.avatar) : currentAssignee.name | tuiInitials"
      />
      <tui-select
        tuiTextfieldSize="s"
        [tuiTextfieldCleaner]="true"
        [(ngModel)]="selectedAssignee"
        [valueContent]="selectContent"
        (tuiValueChanges)="filterAssignee($event)"
      >
        Выберите сотрудника
        <tui-data-list-wrapper
          *tuiDataList
          [itemContent]="selectContent"
          [items]="assigneeList"
        />
      </tui-select>

      <ng-template
        #selectContent
        let-assignee
      >
        <div class="select-template">
          <tui-avatar
            size="xs"
            class="avatar"
            [src]="assignee.avatar ? getImageUri(assignee.avatar) : assignee.name | tuiInitials"
          />
          <div class="name">{{ assignee.name }}</div>
        </div>
      </ng-template>
    </div>

    <div class="col-2">
      <tui-select
        tuiTextfieldSize="s"
        (tuiValueChanges)="filterParams('epic', $event)"
        [tuiTextfieldCleaner]="true"
        [(ngModel)]="selectedEpic"
      >
        Epic
        <tui-data-list-wrapper
          *tuiDataList
          [items]="epicList"
        />
      </tui-select>
    </div>

    <div class="col-2">
      <div tuiGroup [collapsed]="true" class="hide-for-client-role">
        <tui-select
          tuiTextfieldSize="s"
          [valueContent]="headerContent"
          (tuiValueChanges)="filterPayment($event)"
          [tuiTextfieldCleaner]="true"
          [(ngModel)]="selectedPayment"
        >
          Подпроект
          <tui-data-list-wrapper
            *tuiDataList
            [itemContent]="headerContent"
            [items]="paymentList"
          />
        </tui-select>

        <a *ngIf="selectedPayment" [style.flex]="'0 0 auto'" target="_blank" appearance="outline" tuiButton size="s" [routerLink]="['/cabinet/crm/subproject']" [queryParams]="{project: projectId}">
          <tui-icon icon="@tui.trending-up"></tui-icon>
        </a>
      </div>
    </div>

    <div class="col-2">
      <tui-select
        tuiTextfieldSize="s"
        (tuiValueChanges)="filterParams('tag', $event)"
        [tuiTextfieldCleaner]="true"
        [(ngModel)]="selectedTag"
      >
        Приоритет
        <tui-data-list-wrapper
          *tuiDataList
          [items]="tagList"
        />
      </tui-select>
    </div>

    <div class="col-2">
      <tui-select
        tuiTextfieldSize="s"
        (tuiValueChanges)="filterParams('environment', $event)"
        [tuiTextfieldCleaner]="true"
        [(ngModel)]="selectedEnvironment"
      >
        Среда
        <tui-data-list-wrapper
          *tuiDataList
          [items]="environmentList"
        />
      </tui-select>
    </div>

  </div>
  <div class="row">
    <div class="col-2">
      <form [formGroup]="rangeForm">
        <tui-input-date-range
          [tuiTextfieldCleaner]="true"
          style="width: 100%"
          tuiTextfieldSize="s"
          [tuiTextfieldLabelOutside]="true"
          formControlName="dateRange"
          class="tui-input-date-range">
          Дата создания
          <input
            tuiTextfieldLegacy
            placeholder="От - До"/>
        </tui-input-date-range>
      </form>
    </div>

    <div class="col-2">
      <form [formGroup]="releasedForm">
        <tui-input-date-range
          [tuiTextfieldCleaner]="true"
          style="width: 100%"
          tuiTextfieldSize="s"
          [tuiTextfieldLabelOutside]="true"
          formControlName="releasedRange"
          class="tui-input-date-range">
          Дата релиза
          <input
            tuiTextfieldLegacy
            placeholder="От - До"/>
        </tui-input-date-range>
      </form>
    </div>
  </div>
</ng-container>

<ng-template #headerContent let-item>
  {{ item.header }}
</ng-template>
